import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ConfirmationComponent, ConfirmationType } from 'src/app/modal/confirmation/confirmation.component';
import { SuccessDocMessageComponent } from 'src/app/modal/success-message/success-message.component';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { LeadsService } from 'src/app/service/lead.service';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


interface Matter {
  id: number;
  name: string;
  selected: boolean;
}

@Component({
    selector: 'app-attach-matter',
    templateUrl: './attach-matter.component.html',
    styleUrls: ['./attach-matter.component.css'],
    standalone: false
})

export class AttachMatterComponent {
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<number[]>();
  isConfirmDialogVisible = false;
  showSuccessMessage = false;
  searchControl = new FormControl('');
  lead:any;
  matter_type:any;
  // matters: Matter[] = [
  //   { id: 1, name: 'Corporate Law', selected: false },
  //   { id: 2, name: 'child custody case', selected: false },
  //   { id: 3, name: 'legal place', selected: false },
  //   { id: 4, name: 'Corporate Matter', selected: false },
  //   { id: 5, name: 'G M Case Matter', selected: false },
  //   { id: 6, name: 'Firm Case', selected: false },
  //   { id: 7, name: 'Audit Case', selected: false },
  //   { id: 8, name: 'Criminal Matter', selected: false },
  // ];
  matterId:any;
  matters:any[]=[];
  filteredMatters: any[] = [...this.matters];
  docnew:any[]=[];

  constructor(private modalService: NgbModal,private httpService:HttpService, private leadsService:LeadsService, private toastr:ToastrService, private activeModal: NgbActiveModal, private router: Router) {
    this.searchControl.valueChanges.subscribe(value => {
      this.filterMatters(value || '');
    });
  }
  
  ngOnInit(): void {
    this.leadsService.currentLead.subscribe(lead => {
      this.lead = lead; // get doc data
       //console.log('get serviceLead',this.lead)
    });

    // combine the responses
    forkJoin({
      legal: this.httpService.sendGetRequest(URLUtils.getsharedLegal()),
      general: this.httpService.sendGetRequest(URLUtils.getsharedGeneral())
    }).subscribe(({ legal, general }: any) => {
      // console.log('legal',legal)
      // console.log('general',general)

      const leadDocId = this.lead.id; // Current document's ID

      const legalMatters = (legal.matters || []).map((m: any) => {
        const isDisabled = m.ext_doc?.some((doc: any) => doc.docid === leadDocId);
        return {
          id: m.id,
          name: m.title,
          selected: false,
          disabled: isDisabled, // << Add this
          matter_type: "legal",
          external_docs: m.ext_doc
        };
      });

      const generalMatters = (general.matters || []).map((m: any) => {
        const isDisabled = m.ext_doc?.some((doc: any) => doc.docid === leadDocId);
        return {
          id: m.id,
          name: m.title,
          selected: false,
          disabled: isDisabled, // << Add this
          matter_type: "general",
          external_docs: m.ext_doc
        };
      });


      this.matters = [...legalMatters, ...generalMatters];

      this.filteredMatters = [...this.matters]; // For search
       //console.log('filteredMatters', this.filteredMatters)
    });

  }

  get hasSelectedMatters(): boolean {
    return this.matters.some(matter => matter.selected);
  }
  
  filterMatters(searchText: string): void {
    if (!searchText) {
      this.filteredMatters = [...this.matters];
      return;
    }
    
    const lowerCaseSearch = searchText.toLowerCase();
    this.filteredMatters = this.matters.filter(matter => 
      matter.name.toLowerCase().includes(lowerCaseSearch)
    );
  }
  
  selectSingleMatter(selectedMatter: any): void {
    this.matters.forEach(matter => {
      matter.selected = matter === selectedMatter;
    });
  }

  selectMatter(matter: any, event?: Event): void {
    this.toggleMatterSelection(matter, event);
    this.selectSingleMatter(matter);
  }

  toggleMatterSelection(matter: any, event?: Event): void {
    //console.log('matterselected',matter)

    this.docnew = (matter.external_docs).map((m: any) => ({
      docid: m.docid,
      doctype: m.doctype,
    }));

    //console.log('docnew',this.docnew)

    this.matterId = matter.id
    this.matter_type = matter.matter_type
    // Prevent the event from bubbling up if it's coming from the checkbox directly
    if (event) {
      event.stopPropagation();
    }
    
    matter.selected = !matter.selected;
  }
  

    onCancel(): void {
      this.activeModal.dismiss('cancel'); // Properly dismiss the modal
    }
  
   // This method is called when the user clicks Save in the Attach To Matter dialog
   onSave() {
    // Get selected matters before closing
    const selectedMatterIds = this.matters
      .filter(matter => matter.selected)
      .map(matter => matter.id);
    
    // First close the current dialog
    this.activeModal.close();
    this.close.emit();
    
    // Then open the confirmation dialog
    setTimeout(() => {
      this.openConfirmationDialog(selectedMatterIds);
    }, 100); // Small delay to ensure dialog closes first
  }
  
  // Separate method for opening confirmation dialog
  openConfirmationDialog(selectedMatterIds: number[]): void {
    // console.log('selectedMatterIds', selectedMatterIds);
    // console.log('docnew', this.docnew);
    // console.log('lead', this.lead);

    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.confirmationType = ConfirmationType.ATTACH_DOCUMENTS;
    modalRef.componentInstance.selectedMatterIds = selectedMatterIds;
    //  this.docnew.push( {
    //   "docid": this.lead.id,
    //   "doctype": "general"
    // })

    let payload = {
      "documents": [
        {
          "docid": this.lead.id,
          "doctype": "general"
        }
      ],
      "matter_id": this.matterId,
      "matter_type": this.matter_type
    }
    //console.log('payload',payload)

    modalRef.result.then(
      (result) => {
        if (result === 'attached') {
         this.httpService.sendPatchRequest(URLUtils.attachDocumenttoMatter(),payload).subscribe((res: any) => {
           //this.toastr.success(res.msg);
           if(res.error === true){
            this.toastr.error(res.msg);
           }
           else{
            this.showSuccessModal(); // Show success modal after confirmation
           }
           this.activeModal.close(res); 
         });
          // Emit the save event to the parent component
          this.save.emit(selectedMatterIds);
        }
      },
      (reason) => {
        //console.log('Confirmation dismissed:', reason);
      }
    );
  }
  
  // Updated to navigate to view-document page after closing
  private showSuccessModal(): void {
    const successModalRef = this.modalService.open(SuccessDocMessageComponent);
    successModalRef.componentInstance.message = 'Documents have been successfully attached to the selected matter(s).';
    
    // Navigate to view-document page when success modal is closed
    // successModalRef.result.then(
    //   () => {
    //     this.router.navigate(['/viewdoc/:id']);
    //   },
    //   () => {
    //     this.router.navigate(['/viewdoc/:id']);
    //   }
    // );
  }
  
}
